import { render, staticRenderFns } from "./KisiInfo.vue?vue&type=template&id=5841a256"
import script from "./KisiInfo.vue?vue&type=script&lang=ts"
export * from "./KisiInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports